module.exports = __webpack_public_path__ + "static/media/About Us Picture 05.77d2053a.jpg";